import { ObservableArray, View } from "binder"
import { PartNumberSearchViewModel } from "../partNumberManipulation/partNumberManipulation-viewModel";
import { FromPartNumber, PartNumberCanReplaceManipulationViewModel, ToPartNumber } from "./partNumberCanReplaceManipulation-viewModel"
import { FileSelectorViewModel } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class PartNumberCanReplaceManipulationView extends View<PartNumberCanReplaceManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-7CAD2B6D-4355-4810-97A3-CCFF97B0E935"
    }
    loadHtml(): string {
        let element = require('./partNumberCanReplaceManipulation.html').default;
        let style = require('./partNumberCanReplaceManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set fromPartNumbers(v: ObservableArray<FromPartNumber>) { this._fromPartNumbers = v; } public get fromPartNumbers(): ObservableArray<FromPartNumber> { return this._fromPartNumbers;} private _fromPartNumbers: ObservableArray<FromPartNumber>;
    public set toPartNumbers(v: ObservableArray<ToPartNumber>) { this._toPartNumbers = v; } public get toPartNumbers(): ObservableArray<ToPartNumber> { return this._toPartNumbers;} private _toPartNumbers: ObservableArray<ToPartNumber>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set toPartNumberSelector(v: PartNumberSearchViewModel) { this._toPartNumberSelector = v; } public get toPartNumberSelector(): PartNumberSearchViewModel { return this._toPartNumberSelector;} private _toPartNumberSelector: PartNumberSearchViewModel;
    public set fromPartNumberSelector(v: PartNumberSearchViewModel) { this._fromPartNumberSelector = v; } public get fromPartNumberSelector(): PartNumberSearchViewModel { return this._fromPartNumberSelector;} private _fromPartNumberSelector: PartNumberSearchViewModel;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    refresh(){
        this.dataContext.refresh();
    }

    export(){
        this.dataContext.export()
    }

    import(){
        this.dataContext.importFromExcel()
    }

    save(){
        this.dataContext.save()
    }
}
